import React, { memo } from 'react'

const ConditionalWrapper = ({ children, shouldWrap, className }) =>
  shouldWrap ? <div className={className}>{children}</div> : children

export default memo(ConditionalWrapper)
